import { render, staticRenderFns } from "./wagePop.vue?vue&type=template&id=d1c31006"
import script from "./wagePop.vue?vue&type=script&lang=js"
export * from "./wagePop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1c31006')) {
      api.createRecord('d1c31006', component.options)
    } else {
      api.reload('d1c31006', component.options)
    }
    module.hot.accept("./wagePop.vue?vue&type=template&id=d1c31006", function () {
      api.rerender('d1c31006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/reg/wagePop.vue"
export default component.exports